import { ThemeType } from "react-admin";

export const isThemeType = (theme: unknown): theme is ThemeType => {
  return theme === "light" || theme === "dark";
};
